import { render, staticRenderFns } from "./RequestProfileRemove.vue?vue&type=template&id=52e6aa0a&"
import script from "./RequestProfileRemove.vue?vue&type=script&lang=js&"
export * from "./RequestProfileRemove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52e6aa0a')) {
      api.createRecord('52e6aa0a', component.options)
    } else {
      api.reload('52e6aa0a', component.options)
    }
    module.hot.accept("./RequestProfileRemove.vue?vue&type=template&id=52e6aa0a&", function () {
      api.rerender('52e6aa0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Profile/Privacy/RequestProfileRemove.vue"
export default component.exports